import Menu from "../../components/Menu"
import RoundyContainer from "../../components/RoundyContainer"
import { HouseholdChangeContextComp } from "../../components/ChangeRequest_HouseholdChangeComp/HouseholdChangeContext"
import HouseholdProgressBarSect from "../../components/UpdateDriversComp/HouseholdProgressBarSect"
import HouseholdAdditional_Main from "components/ChangeRequest_HouseholdChangeComp/2_Additional/HouseholdAdditional_Main"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"

const UpdateHouseholdAdditional = (props) => {
    const { userData } = props.user
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0)
        navigate("/404")
        return
    }, [])
    return (
        <>
        <HouseholdChangeContextComp>
            <Menu Title={"HOUSEHOLD CHANGE"} FirstName={userData.firstName} userData={userData} />
            <HouseholdProgressBarSect screen={"Additional"} />
            <RoundyContainer Content={HouseholdAdditional_Main} NoRoundy
                params={{
                    storedData: { ...props.storedData },
                    setStoredData: props.setStoredData
                }}
            />
        </HouseholdChangeContextComp>
        </>
    )
}

export default UpdateHouseholdAdditional